{
  "title": "Customers",
  "description": "People who have booked appointments with your business.",
  "searchPlaceholder": "Search customers...",
  "columns": {
    "phone": "Phone",
    "verified": "Verified",
    "joined": "Joined"
  },
  "show": {
    "notFound": "Customer not found.",
    "back": "Back to customers",
    "unnamed": "Unnamed customer",
    "verified": "Verified",
    "unverified": "Unverified",
    "phone": "Phone",
    "email": "Email",
    "joined": "Joined",
    "appointmentsTitle": "Appointments",
    "emptyAppointmentsTitle": "No appointments yet",
    "emptyAppointmentsDescription": "This customer has not booked any appointments with your business."
  }
}
